import { render, staticRenderFns } from "./prescriptionInfo.vue?vue&type=template&id=72f83a14&"
import script from "./prescriptionInfo.vue?vue&type=script&lang=js&"
export * from "./prescriptionInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports